import { httpClient } from "./httpClient";
import { Permissao } from "./RoleService";

export class PermissaoService {
  private readonly basePath = "/api/v1/permissoes";

  async getPermissions() {
    return httpClient.get<Permissao[]>(this.basePath);
  }
}

export const permissaoService = new PermissaoService();
